export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
export function formatNumberValue(value, maximumDecimals, minimumDigits) {
    const formatter = new Intl.NumberFormat(undefined, {
        maximumFractionDigits: maximumDecimals ?? 0,
        minimumIntegerDigits: minimumDigits ?? 1,
    });
    return formatter.format(value);
}
/** Clamp index to be within the min/max index range. */
export function clamp(value, max) {
    return Math.max(Math.min(value, max), 0);
}
/**
 * Rule structure for react-hook-form
 */
export const EMAIL_RULE = {
    message: `Please enter a valid email address`,
    value: /^[\w\-.\d*]+@[\w\-\d.]+(\.\w*)$/,
};
export function isEmpty(item) {
    if (typeof window === 'undefined')
        return true;
    if (Array.isArray(item))
        return !item.length;
    if (typeof item === 'string')
        return !item.trim().length;
    if (item instanceof Date)
        return isNaN(item.valueOf());
    if (typeof item === 'number')
        return false;
    return !item;
}
